<template>
  <v-flex class="expanded_post_image">
    <v-flex class="commeted_users__close">
      <v-btn data-qe-id="photo_dialog_close_btn" flat
             icon
             @click="closePhotoDialog()">
        <v-icon class="fas fa-times"></v-icon>
      </v-btn>
    </v-flex>
    <v-layout fill-height row wrap>

      <v-flex class="post_bckgrnd" lg7 md6>
        <v-carousel v-if="postImageList.length"
                    v-model="imageStartIndex"
                    hide-delimiters>
          <v-carousel-item
              v-for="(postImg,i) in postImageList"
              :key="i"
              :src="sizeFormattedImageUrl(postImg.url, 900)"
              contain
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-flex lg5 md6>
        <v-flex class="post_details">
          <v-layout row wrap>
            <post-owner :actions="postActions" :post="expandPhotoObj"></post-owner>
            <v-flex xs12>
              <div v-if="expandPhotoObj.body" class="expanded_post_image__body">
                <span v-html="epPostMessage"></span>
                <span v-if="isShowSeeMore" class="activity-post__seemore">
                                    <a data-qe-id="post_see_more_btn" @click="seeMorePostMessage()">
                                        {{ appCommonConstants.SEE_MORE }}
                                    </a>
                                </span>
              </div>
            </v-flex>
            <v-flex class="expanded_post_image__likes" xs12>
              <v-flex v-if="expandPhotoObj.likeCount || expandPhotoObj.commentCount">
                <v-divider></v-divider>
              </v-flex>
              <span v-if="expandPhotoObj.likeCount"
                    class="expanded_post_image__likesStatement"
                    data-qe-id="post_show_likers_btn_link"
                    @click="showEPLikedUsers()">{{ likesForThePost }} </span>
              <span v-if="!isAdminPageFeed && expandPhotoObj.commentCount"
                    class="expanded_post_image__commentsStatement"
                    @click="showEPCommentedUsers()">{{ commentEPForThePost }}</span>
              <post-control
                  :activity="expandPhotoObj"
                  :can-like="canEditAllActivityFeed"
                  :handle-comment="handleComment"
                  :handle-like="handleLike"
                  :show-comment="expandPhotoObj.canComment">
              </post-control>
            </v-flex>
            <v-flex v-if="toggleComment" class="expanded_post_image__comments" xs12>
              <add-comment
                  v-if="expandPhotoObj.canComment && !isAdminPageFeed && !expandPhotoObj.featuredComments.length"
                  :comment-count-value="expandPhotoObj.commentCount" :parent-id="expandPhotoObj.id"></add-comment>
              <comment-list
                  v-if="expandPhotoObj.featuredComments.length"
                  :can-comment="expandPhotoObj.canComment"
                  :can-edit-all-activity-feed="canEditAllActivityFeed"
                  :comment-count-value="expandPhotoObj.commentCount"
                  :comment-list="expandPhotoObj.featuredComments"
                  :inappropriate-children="expandPhotoObj.inappropriateChildren"
                  :isAdminPageFeed="isAdminPageFeed"
                  :parent-post-id="expandPhotoObj.id">
              </comment-list>
            </v-flex>
            <v-dialog v-model="dialogState.dialogOpen" class="expanded_post_image__dialog_box" width="400">
              <commented-users
                  v-if="dialogState.dialogOpen"
                  :comment-count="expandPhotoObj.commentCount"
                  :dialog-state="dialogState"
                  :post-id="expandPhotoObj.id"
                  :user-has-commented="expandPhotoObj.userHasCommented">
              </commented-users>
            </v-dialog>
            <v-dialog v-model="likeDialogState.likeDialogOpen" class="activity-post__dialog_box" width="400">
              <liked-users
                  v-if="likeDialogState.likeDialogOpen"
                  :like-count="expandPhotoObj.likeCount"
                  :like-dialog-state="likeDialogState"
                  :post-id="expandPhotoObj.id"
                  :user-has-liked="expandPhotoObj.userHasLiked"></liked-users>
            </v-dialog>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import PostOwner from "../PostOwner/PostOwner";
import {
  communityCommonConstant,
  likeStatement,
  commentStatement,
  postActions,
} from "../communityCommon.constant";
import PostControl from "./PostControl";
import CommentList from "../Comment/CommentList";
import AddPost from "../AddPost/AddPost";
import AddComment from "../AddComment/AddComment";
import { mapActions } from "vuex";
import { storeAction } from "../../../store/storeActions.constant";
import CommentedUsers from "../CommentedUsers/CommentedUsers";
import LikedUsers from "../CommentedUsers/LikedUsers";
import { appCommonConstants } from "../../appCommon.constants";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
  name: "ExpandedImage",
  components: {
    AddComment,
    AddPost,
    CommentList,
    PostControl,
    PostOwner,
    CommentedUsers,
    LikedUsers,
  },
  created() {
    this.postactivityobjMessage();
    this.toggleComment = this.expandPhotoObj && this.expandPhotoObj.featuredComments
    && this.expandPhotoObj.featuredComments.length
    && this.expandPhotoObj.hasOwnProperty('showAllCommentsAndReplies')
        ? this.expandPhotoObj.showAllCommentsAndReplies
        : false;
    if (this.postImageList.length && this.expandedImageIndex) {
      this.imageStartIndex = this.expandedImageIndex;
    }
  },
  data: () => ({
    communityCommonConstant,
    appCommonConstants,
    postActions,
    epPostMessage: "",
    toggleComment: false,
    dialogState: {
      dialogOpen: false,
    },
    likeDialogState: {
      likeDialogOpen: false,
    },
    isShowSeeMore: false,
    imageStartIndex: 0,
    sizeFormattedImageUrl,
  }),
  props: {
    expandPhotoObj: {
      type: Object,
      default: () => ({}),
    },
    expandPhoto: {
      type: Object,
      default: () => ({}),
    },
    isAdminPageFeed: {
      type: Boolean,
      default: false,
    },
    expandedImageIndex: {
      type: Number,
      required: true,
    },
    canEditAllActivityFeed: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions({
      sendLike: `chapter/${storeAction.sendLike}`,
      sendUnlike: `chapter/${storeAction.sendUnlike}`,
    }),
    isImageType(type) {
      return new RegExp(`${this.appCommonConstants.IMAGE_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
    },
    isVideoType(type) {
      return new RegExp(`${this.appCommonConstants.VIDEO_FILE_TYPES_ACCEPTED}`.replace(/,/g, '|')).test(type);
    },
    handleLike() {
      if (this.expandPhotoObj.userHasLiked) {
        this.sendUnlike(this.expandPhotoObj.id);
        return true;
      }
      if (!this.expandPhotoObj.userHasLiked) {
        this.sendLike(this.expandPhotoObj.id);
        return true;
      }
    },
    handleComment() {
      this.toggleComment = !this.toggleComment;
      return true;
    },
    showEPCommentedUsers() {
      this.dialogState.dialogOpen = true;
    },
    showEPLikedUsers() {
      this.likeDialogState.likeDialogOpen = true;
    },
    postactivityobjMessage() {
      const dots = "...";
      if (this.expandPhotoObj && this.expandPhotoObj.body) {
        this.epPostMessage = this.expandPhotoObj.body;
        if (this.expandPhotoObj.body.length > 200) {
          this.epPostMessage = this.expandPhotoObj.body.substring(0, 200) + dots;
          this.isShowSeeMore = true;
        }
      }
    },
    seeMorePostMessage() {
      this.epPostMessage = this.expandPhotoObj.body;
      this.isShowSeeMore = false;
    },
    closePhotoDialog() {
      this.expandPhoto.expandOpen = false;
    },
  },
  computed: {
    commentEPForThePost() {
      return commentStatement(this.expandPhotoObj);
    },
    likesForThePost() {
      return likeStatement(this.expandPhotoObj);
    },
    postImageList() {
      return this.expandPhotoObj && this.expandPhotoObj.postImage && this.expandPhotoObj.postImage.length
          ? this.expandPhotoObj.postImage.filter(pImg => this.isImageType(pImg.mediaType))
          : [];
    },
  },
};
</script>

<style lang="scss">
@import "../../../common/styles/_colors.scss";
@import "../../../common/styles/_responsive.scss";

.expanded_post_image {
  position: fixed;
  height: 100%;
  top: 0;
  width: 100%;
  left: 0;
  background: $black;
  padding: 10px;

  .post_details {
    padding: 50px 10px 0 10px;

    .v-list__tile {
      padding-left: 0;
    }

    .owner__time_align {
      padding-right: 5px;
    }
  }

  &__body {
    color: $ypo-gray-text;
    font-size: 14px;
    line-height: 24px;
    padding: 10px 10px 10px 0;
    margin-left: 60px;
    word-break: break-word;
  }

  &__likes {
    position: relative;
    padding: 15px 5px 10px 5px;
    margin-top: 40px;

    &Statement {
      color: $ypo-gray-text;
      font-size: 12px;
      letter-spacing: 0.36px;
      position: absolute;
      left: 5px;
      top: -12px;
      padding-bottom: 5px;
      width: 45%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  &__commentsStatement {
    color: $ypo-gray-text;
    font-size: 12px;
    letter-spacing: 0.36px;
    position: absolute;
    top: -12px;
    padding-bottom: 5px;
    right: 5px;
    width: 45%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: right;
  }

  &__comments {
    background: $ypo-extra-light-gray;

    .post {
      min-height: inherit;
      margin: 10px;

      &-expand-block {
        width: auto;
      }

      textarea {
        height: 45px;
        margin: 0 !important;
      }
    }
  }

  .first-like-comment {
    margin: 15px -15px -15px -15px !important;
  }

  .post_bckgrnd {
    padding: 5px;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .commeted_users__close {
    position: absolute;
    right: 8px;
    top: 10px;
    z-index: 1;

    .v-btn {
      top: 0;
      right: 0;
    }

    i {
      color: $ypo-gray-text;
      font-size: 18px;
    }
  }

  .post__Allow_Comments {
    padding-right: 10px;
  }

  .post_details {
    background: $white;
    max-height: 95vh;
    min-height: 95vh;
    overflow-y: auto;
    margin: 5px;
    padding: 50px 20px;

  }
}

@media (max-width: 1023px) {
  .expanded_post_image {
    .commeted_users__close {
      background: rgba($ypo-extra-light-gray, 0.8);
      border-radius: 50%;
    }

    .post_details {
      min-height: 45vh;
      max-height: 45vh;
    }

    .post_bckgrnd {
      min-height: 50vh;
    }

  }

}

@media (max-width: 767px) {
  .expanded_post_image {
    .commeted_users__close .v-btn {
      background: rgba($white, 0.9);
    }
  }
}
</style>
